import gql from 'graphql-tag';

export const GET_MEMBERS_BY_COMMUNITY_QUERY = gql`
  query GetMembersByCommunity($communityId: Int!, $skip: Int, $take: Int) {
    members(communityId: $communityId, skip: $skip, take: $take) {
      id
      name
      email
      instagramUsername
    }
  }
`;
